// PluginContract_CodeNode.ts
export const CodeNodeContract = {
  pluginName: 'CodePlugin',
  nodeTypes: ['CodeNode'],
  register: (editor: any) => {
    editor.registerNodeType?.('CodeNode');
    console.log('🔌 [CodePlugin] Registered CodeNode');
  },
};